<template>
    <div id="app" v-if="initialized">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initialized: false,
        };
    },
    methods: {
        async checkLogin() {
            console.log("TOKEN: ", this.$localStorage.get("token"))
            if (this.$route.path !== "/login") {
                if (this.$localStorage.get("token")) {
                    // Token exist
                    try {
                        await this.$axios.get("/validate");
                        this.$store.dispatch("setToken", this.$localStorage.get("token"));
                    } catch (e) {
                        this.$localStorage.remove("token");
                        this.$router.replace("/login");
                    }
                } else {
                    this.$router.replace("/login");
                }
            }
            this.initialized = true;
            let loading = document.getElementById("main-loading");
            if (loading) {
                loading.remove();
            }
        },
    },
    created() {
        document.title = "MET Admin Panel";
        /* Check for token */
        this.checkLogin();
    },
    mounted() {},
};
</script>

<style>
</style>